var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "relative ",
      class: {
        "w-full": _vm.isMobile() && _vm.showSidebarOnMobile,
        " lg:flex flex-col  w-full max-w-xs flex-grow flex-shrink-0 border-l bg-gray-100 overflow-y-auto relative z-10": !_vm.isMobile()
      }
    },
    [
      _vm.isMobile() && !_vm.showSidebarOnMobile
        ? _c(
            "button",
            {
              staticClass:
                "absolute z-50 top-15 right-0 bg-indigo-500 rounded-l-md  text-white p-2",
              on: { click: _vm.toggleSidebar }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "h-6 w-6",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M11 19l-7-7 7-7m8 14l-7-7 7-7"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            " lg:flex flex-col  w-full max-w-xs flex-grow flex-shrink-0 border-l bg-gray-100 overflow-y-auto",
          class: {
            "absolute z-50": _vm.isMobile() && _vm.showSidebarOnMobile,
            "relative z-10": !_vm.isMobile(),
            hidden: _vm.isMobile() && !_vm.showSidebarOnMobile
          }
        },
        [
          _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "  w-full justify-center items-center overflow-hidden  rounded-lg  mx-auto"
              },
              [
                _vm.isMobile() && _vm.showSidebarOnMobile
                  ? _c(
                      "div",
                      {
                        staticClass: "flex justify-end",
                        on: { click: _vm.toggleSidebar }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "h-6 w-6",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M6 18L18 6M6 6l12 12"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "relative h-4" }),
                _c("div", { staticClass: "flex justify-center" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center  bg-indigo-500 flex-shrink-0 text-white rounded-full  shadow border-4 border-white  h-24 w-24 "
                    },
                    [_vm._v(" " + _vm._s(_vm.getFirstCharacter()) + " ")]
                  )
                ]),
                _vm.conversation.customer
                  ? _c("div", { staticClass: "mt-4" }, [
                      _c(
                        "h1",
                        {
                          staticClass:
                            "text-lg font-inter leading-loose text-center font-medium text-gray-600"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.conversation.customer.firstName) +
                              " " +
                              _vm._s(_vm.conversation.customer.lastName) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass:
                            "text-xs font-inter leading-normal text-center font-medium text-cool-gray-500 uppercase"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.conversation.customer.phoneNumber) +
                              " "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm.isLoading
                  ? _c("div", { staticClass: "text-center mt-2 text-sm" }, [
                      _vm._v(" Loading.... ")
                    ])
                  : _vm._e(),
                !_vm.isLoading &&
                _vm.customer &&
                Object.keys(_vm.customer).length > 0
                  ? _c("div", [
                      _vm.customer
                        ? _c(
                            "div",
                            { staticClass: "flex justify-center mt-4" },
                            [
                              _c("div", { staticClass: "flex flex-col mx-4" }, [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase"
                                  },
                                  [_vm._v(" lifetime value ")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "font-inter text-center font-medium text-cool-gray-500 uppercase my-4"
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.customer.lifetimeVal)
                                    )
                                  ]
                                )
                              ]),
                              _c("div", { staticClass: "flex flex-col mx-4" }, [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase"
                                  },
                                  [_vm._v(" Customer since ")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "font-inter text-center font-medium text-cool-gray-500 my-4"
                                  },
                                  [_vm._v(_vm._s(_vm.customer.createdAt))]
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _c("div", [
                        _c("div", { staticClass: "px-2" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.productSearchText,
                                expression: "productSearchText"
                              }
                            ],
                            staticClass:
                              "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md border p-2 ",
                            attrs: {
                              type: "text",
                              placeholder: "search products"
                            },
                            domProps: { value: _vm.productSearchText },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.productSearchText = $event.target.value
                                },
                                _vm.searchProducts
                              ]
                            }
                          })
                        ]),
                        _vm.products.length > 0
                          ? _c(
                              "ul",
                              {
                                staticClass:
                                  "absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                                attrs: {
                                  tabindex: "-1",
                                  role: "listbox",
                                  "aria-labelledby": "listbox-label",
                                  "aria-activedescendant": "listbox-option-3"
                                }
                              },
                              _vm._l(_vm.products, function(product, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    staticClass:
                                      "text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9",
                                    attrs: {
                                      id: "listbox-option-0",
                                      role: "option"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex items-center" },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "flex-shrink-0 h-6 w-6 rounded-full",
                                          attrs: { src: product.image, alt: "" }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "font-normal ml-3 block truncate"
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(product.title) + " "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-indigo-600 absolute inset-y-0 right-0 flex items-center pr-4 cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.sendProductLinkToChat(
                                              product
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(" Send to chat ")]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]),
                      _vm.customer.defaultAddress
                        ? _c("div", { staticClass: "mt-4  " }, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase"
                              },
                              [_vm._v(" default address ")]
                            ),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-xs font-inter leading-normal text-cool-gray-500 px-2 py-2"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.customer.defaultAddress.first_name
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.customer.defaultAddress.last_name
                                    ) +
                                    " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.customer.defaultAddress.address1
                                    ) +
                                    " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.customer.defaultAddress.address2
                                    ) +
                                    " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.customer.defaultAddress.zip) +
                                    " " +
                                    _vm._s(_vm.customer.defaultAddress.city) +
                                    " " +
                                    _vm._s(
                                      _vm.customer.defaultAddress.province
                                    ) +
                                    " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.customer.defaultAddress.country_name
                                    ) +
                                    " "
                                ),
                                _c("br")
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm.customer && Object.keys(_vm.customer).length > 0
                        ? _c("div", {}, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase py-4"
                              },
                              [_vm._v(" Recent orders ")]
                            ),
                            _c(
                              "div",
                              { staticClass: "overflow-hidden rounded px-2" },
                              [
                                _c("table", { staticClass: "min-w-full " }, [
                                  _vm._m(0),
                                  _c(
                                    "tbody",
                                    { staticClass: "text-cool-gray-500" },
                                    _vm._l(_vm.orders, function(order, index) {
                                      return _c("tr", { key: index }, [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-left text-xs py-2 px-2  font-inter leading-normal "
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "text-blue-500",
                                                attrs: {
                                                  href: order.url,
                                                  target: "_blank"
                                                }
                                              },
                                              [_vm._v(_vm._s(order.num))]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-left text-xs py-2 px-2  font-inter leading-normal text-cool-gray-500"
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(order.date) + " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-left text-xs py-2 px-2  font-inter leading-normal text-cool-gray-500"
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(order.status) + " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-left text-xs py-2 px-2  font-inter leading-normal text-cool-gray-500"
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(order.amount) + " "
                                            )
                                          ]
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              ]
                            )
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "mt-4 " }, [
                        _c(
                          "h6",
                          {
                            staticClass:
                              "text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase"
                          },
                          [_vm._v(" Tags ")]
                        ),
                        _vm.customer.tags && _vm.customer.tags.length === 0
                          ? _c("span", [_vm._v("No tags")])
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-xs font-inter leading-normal text-cool-gray-500 px-2 py-2"
                          },
                          [_vm._v(" " + _vm._s(_vm.customer.tags) + " ")]
                        )
                      ]),
                      _c("div", { staticClass: "mt-4 " }, [
                        _c(
                          "h6",
                          {
                            staticClass:
                              "text-xs font-inter leading-normal text-center font-medium text-cool-gray-600 uppercase"
                          },
                          [_vm._v(" Note ")]
                        ),
                        _vm.customer.note && _vm.customer.note.length === 0
                          ? _c("span", [_vm._v("No tags")])
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-xs font-inter leading-normal text-cool-gray-500 px-2 py-2"
                          },
                          [_vm._v(" " + _vm._s(_vm.customer.note) + " ")]
                        )
                      ])
                    ])
                  : _vm._e(),
                !_vm.isLoading &&
                _vm.customer &&
                Object.keys(_vm.customer).length === 0
                  ? _c("div", { staticClass: "text-center mt-2 text-sm" }, [
                      _vm._v(" Customer not found ")
                    ])
                  : _vm._e()
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "bg-white-two " }, [
      _c("tr", [
        _c(
          "th",
          {
            staticClass:
              "text-xs  font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2"
          },
          [_vm._v(" Order Id ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "text-xs font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2"
          },
          [_vm._v(" Created at ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "text-xs font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2"
          },
          [_vm._v(" status ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "text-xs font-inter leading-loose font-medium text-cool-gray-500 uppercase py-2"
          },
          [_vm._v(" Amount ")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }